// extracted by mini-css-extract-plugin
var _1 = "infotext_icon__1wp0x";
var _2 = "infotext_wrapper__qamq8";
export { _1 as "icon", _2 as "wrapper" }
